import React, { useState,useRef,useEffect} from "react";
import { Link, useNavigate,useLocation } from "react-router-dom";
import arrow_down from "../public/assets/img/arrow-down.svg";
import { getUser } from "../../utils/helper"
import './Sidebar.css';
import { IoMdHome } from "react-icons/io";
import { IoIosPeople } from "react-icons/io";
import { IoMdPerson } from "react-icons/io";
import { MdPeople } from "react-icons/md";
import { FaBloggerB } from "react-icons/fa";
import { FaRegAddressCard } from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";
import { FaAngleDown } from "react-icons/fa";
import no_user from "../public/assets/img/no_user.png";

import {
  FaTachometerAlt,
  FaUser,
  FaSignOutAlt,
  FaUsers,
  FaUserFriends,
  FaNewspaper,
} from "react-icons/fa";
import axios from "axios";

const Sidebar = ({ isOpen, toggleSidebar, user }) => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [userInfo, setUserInfo] = useState(null);
  const hasFetched = useRef(false);
  const location = useLocation();
 
  const getUserDataFromCookies = () => {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === "userData") {
        return JSON.parse(decodeURIComponent(value));
      }
    }
    return null;
  };

  const userData = getUserDataFromCookies();
  const userRoleId = user ? user.role_id : null;


  const handleLogout = async () => {
    try {
      await axios.get(`${API_BASE_URL}logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      localStorage.removeItem("token");
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = `${name}=; expires=Thu, 01 Jan 2024 00:00:00 GMT; path=/`;
      }
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };
   useEffect(() => {
      const fetchUserData = async () => {
        if (!hasFetched.current) {
          const data = await getUser();
          setUserInfo(data?.data?.user || null);
          hasFetched.current = true;
        }
      };
  
      fetchUserData();
    }, []);

  return (
    // <div className={`sidebar${isOpen ? '' : ' collapsed'}`} id="sidebar">
    <div className="sidebar white-box-shadow" id="sidebar">
      <div className="sidebar-header">
        <Link className="navbar-brand bg-white mx-auto" to="">

          {/* {isOpen ? (
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
              alt="Logo"
              style={{ width: '220px', }}
            />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/localshouts.png`}
              alt="Logo"
            />
          )} */}
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
            alt="Logo"
            style={{ width: '200px', }}
          />
        </Link>
      </div>

      <div className="nav-body d-flex flex-column">

        <div className="nav-divider"></div>

        <div className="d-flex logged-user py-3">
          <div className="photo">
           <img
                src={
                  userInfo?.logo
                    ? `${userInfo.logo}`
                    : `${no_user}`
                }
                alt="Profile"
                className="rounded-circle"
                style={{ width: "50px", height: "50px", objectFit: "cover", cursor: "pointer" }}
              />
          </div>
          <div className="info d-flex flex-column ms-1">
            {/* <div className="role">PRODUCT MANAGER</div> */}
            <div className="name"> {userInfo?.name || "User"}</div>
          </div>
        </div>

        <div className="nav-divider"></div>

        <div className="nav-main d-flex flex-column py-3">
          <div className="nav-section-header">MAIN</div>
          <ul className="d-flex flex-column">

            {(userRoleId === 1 || userRoleId === 3) &&
              <li  className={`cursor-pointer ${
                  location.pathname === "/dashboard" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/dashboard" className="d-flex align-items-center gap-1">
                  <div>
                    <i className="icon-dashboard"></i>
                  </div>
                  <div className="">Dashboard</div>
                </Link>
              </li>
            }

             {userRoleId === 1 &&
              <li className={`cursor-pointer ${
                  location.pathname === "/staff" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/staff" className="d-flex align-items-center gap-1">
                  <div>
                  <i className="fa-regular fa-user me-1"></i>
                    {/* <FaUsers className="me-1" /> */}
                    {/* <IoIosPeople className="me-1" /> */}
                  </div>
                  <div className="">Staff</div>
                </Link>
              </li>
            }

            {userRoleId === 1 &&
              <li className={`cursor-pointer ${
                  location.pathname === "/affilate" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/affilate" className="d-flex align-items-center gap-1">
                  <div>
                    <i className="icon-affilate"></i>
                  </div>
                  <div className="">Affiliate</div>
                </Link>
              </li>
            }

            {userRoleId === 1 &&
              <li className={`cursor-pointer ${
                  location.pathname === "/client" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/client" className="d-flex align-items-center gap-1">
                  <div>
                    <i className="icon-client"></i>
                  </div>
                  <div className="">Client</div>
                </Link>
              </li>
            }

            {userRoleId === 1 &&
              <li className={`cursor-pointer ${
                  location.pathname === "/leads" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/leads" className="d-flex align-items-center gap-1">
                  <div>
                    <i className="icon-lead"></i>
                  </div>
                  <div className="">Leads</div>
                </Link>
              </li>
            }

            {userRoleId === 1 &&
              <li className={`cursor-pointer ${
                  location.pathname === "/blogs" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/blogs" className="d-flex align-items-center gap-1">
                  <div>
                    <i className="icon-blog"></i>
                  </div>
                  <div className="">Blogs</div>
                </Link>
              </li>
            }
            {(userRoleId === 1 || userRoleId === 3) &&
              <li className={`cursor-pointer ${
                  location.pathname === "/vcards" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                <Link to="/vcards" className="d-flex align-items-center gap-1">
                  <div>
                    <i className="icon-v-card"></i>
                  </div>
                  <div className="">Vcards</div>
                </Link>
              </li>

            }

            {/* <li className="d-flex flex-column">
              <div className="d-flex">
                <div>
                  <i className="icon-briefcase"></i>
                </div>
                <div>Vcards</div>
                <div>
                  <i className="icon-briefcase"></i>
                </div>
              </div>
              <div>
                <ul className="d-flex flex-column">
                  <li>Index</li>
                  <li>Create</li>
                  <li>Declines</li>
                  <li>Payouts</li>
                </ul>
              </div>
            </li> */}
          </ul>
        </div>

        <div className="nav-divider"></div>

        <div className="nav-settings d-flex flex-column py-3">
          <div className="nav-section-header">SETTINGS</div>
          <div className="d-flex">
            <ul className="w-100 mb-0">
              {(userRoleId === 1 || userRoleId === 3) &&

                <li className={`cursor-pointer ${
                  location.pathname === "/setting" ? "nav-link-active" : ""
                }`} onClick={toggleSidebar}>
                  <Link to="/setting" className="d-flex align-items-center gap-1">
                    <div>
                      <i className="icon-setting"></i>
                      {/* <FaNewspaper className="me-1" /> */}
                      {/* <IoSettingsSharp className="me-1" /> */}
                    </div>
                    <div className="">Settings</div>
                    <div className="ms-auto">
                      {/* <i className="icon-briefcase"></i> */}
                      {/* <img
                        src={arrow_down}
                        alt="logo"
                        style={{
                          width: "20px",
                        }}
                      /> */}
                      {/* <FaAngleDown /> */}
                    </div>
                  </Link>
                </li>
              }
            </ul>
          </div>
        </div>

        <div class="nav-divider"></div>

        <div className="nav-bottom d-flex flex-column py-3">
          <div className="d-flex">
            <ul className="w-100">
              {(userRoleId === 1 || userRoleId === 3) &&

                  <li className="cursor-pointer logout" onClick={handleLogout}>
                  <div className="d-flex">
                  <div>
                      {/* <i className="icon-briefcase"></i> */}
                      <FaSignOutAlt className="me-1" />
                    </div>
                    <div className="text">Logout Account</div>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>


      </div>

      {/* <ul className="pt-2"> */}
      {/* {userRoleId} */}
      {/* {(userRoleId === 1 || userRoleId === 3) &&
          <li>
            <Link to="/dashboard">
              <FaTachometerAlt /> Dashboard
            </Link>
          </li>
        }
        {userRoleId === 1 &&
          <li>
            <Link to="/affilate">
              <FaUsers /> Affiliate
            </Link>
          </li>
        }
        {userRoleId === 1 &&
          <li>
            <Link to="/client">
              <FaUser /> Client
            </Link>
          </li>
        }
        {userRoleId === 1 &&
          <li>
            <Link to="/leads">
              <FaUserFriends /> Leads
            </Link>
          </li>
        }
        {userRoleId === 1 &&
          <li>
            <Link to="/blogs">
              <FaNewspaper /> Blogs
            </Link>
          </li>
        }
        {(userRoleId === 1 || userRoleId === 3) &&
          <li>
            <Link to="/businessList">
              <FaNewspaper /> Vcards
            </Link>
          </li>

        }
        {(userRoleId === 1 || userRoleId === 3) &&
          <li>
            <Link to="/setting">
              <FaNewspaper /> Settings
            </Link>
          </li>

        }

        <li onClick={handleLogout} style={{ cursor: 'pointer', color: 'red' }} className="border-top mt-2">
          <FaSignOutAlt /> Logout
        </li>
      </ul> */}

      {/* Uncomment above */}

      {/* <ul className="pt-2">
     
          <li>
            <Link to="/dashboard">
              <FaTachometerAlt /> Dashboard
            </Link>
          </li>
      
       
          <li>
            <Link to="/affilate">
              <FaUsers /> {isOpen && 'Affiliate'}
            </Link>
          </li>
      
      
          <li>
            <Link to="/client">
              <FaUser /> {isOpen && 'Client'}
            </Link>
          </li>
       
          <li>
            <Link to="/leads">
              <FaUserFriends /> {isOpen && 'Leads'}
            </Link>
          </li>
      
          <li>
            <Link to="/blogs">
              <FaNewspaper /> {isOpen && 'Blogs'}
            </Link>
          </li>
     
          <li>
            <Link to="/businessList">
              <FaNewspaper /> Vcards
            </Link>
        </li>
        
        <li>
          <Link to="">
            <FaNewspaper /> Settings
          </Link>
           </li>

          <li onClick={handleLogout} style={{ cursor: 'pointer', color: 'red' }} className="border-top mt-2">
              <FaSignOutAlt /> Logout
          </li>
      </ul> */}

    </div>







    // <div class="container-fluid">
    //   <div class="row flex-nowrap">
    //     <div class="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark">
    //       <div class="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
    //         <a
    //           href="/"
    //           class="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
    //         >
    //           <span class="fs-5 d-none d-sm-inline">Menu</span>
    //         </a>
    //         <ul
    //           class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
    //           id="menu"
    //         >
    //           <li class="nav-item">
    //             <Link to="/dashboard" className="nav-link align-middle px-0">
    //               <FaTachometerAlt /> {isOpen && "Dashboard"}
    //             </Link>
    //           </li>
    //           {userRoleId === 1 && (
    //           <li class="nav-item">
    //             <Link to="/affilate" className="nav-link align-middle px-0">
    //               <FaUsers /> {isOpen && "Affiliate"}
    //             </Link>
    //           </li>
    //           )}
    //           <li class="nav-item">
    //             <Link to="/client" className="nav-link align-middle px-0">
    //               <FaUser /> {isOpen && "Client"}
    //             </Link>
    //           </li>
    //           <li class="nav-item">
    //             <Link to="/leads" className="nav-link align-middle px-0">
    //               <FaUserFriends /> {isOpen && "Leads"}
    //             </Link>
    //           </li>
    //           <li class="nav-item">
    //             <Link to="/blogs" className="nav-link align-middle px-0">
    //               <FaNewspaper /> {isOpen && "Blogs"}
    //             </Link>
    //           </li>
    //           <li class="nav-item">
    //             <Link to="/businessList" className="nav-link align-middle px-0">
    //               <FaNewspaper /> {isOpen && "Business"}
    //             </Link>
    //           </li>
    //           <li onClick={handleLogout} style={{ cursor: 'pointer' }} className="nav-link align-middle px-0">
    //              <FaSignOutAlt /> {isOpen && 'Logout'}
    //          </li>
    //         </ul>
    //       </div>
    //     </div>
    //     <div class="col py-3">
    //         Content area...
    //     </div>
    //   </div>
    // </div>
  );
};

export default Sidebar;
